import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, TablePagination, TableFooter } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import styled from 'styled-components';
import { useForm } from "react-hook-form";
import { useAddSubInReqCatMutation, useDelReqSubInArrMutation} from '../../../features/reqmaster/reqmasterSlice';



const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`

const SpecInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

const tarray = (array,data,resultarray=[])=>{
  for(const val of array){
    for(const key of val.Subject){
        let tempobject ={};        
        tempobject= {...tempobject,"id":val.id,"Category":val.Category,"Subject":key}
        resultarray.push(tempobject);
    }
}
return resultarray;
}

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const SubjectMaster = ({reqmaster, categProp, categPropId, onClickBackArrow,setSentData, deleteAssetMaster}) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [addSubjectData, setAddSubjectData] = useState({});
    const [addSpecIndex, setAddSpecIndex] = useState(1);

    const [addSubInCatReq] = useAddSubInReqCatMutation();
    const [delSubInArrReq] = useDelReqSubInArrMutation();
  
    const rows = tarray(Object.values(reqmaster)); 
   
   
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      };
  
    const onClickaddicon = () =>{
      setAddSpecIndex(addSpecIndex+1)
      }
  
    const onClickremoveicon = () =>{
      let temp = {...addSubjectData};
      for(const key in temp){
        console.log(key.charAt(key.length-1))
        console.log(addSpecIndex-1)
          const levelIndex = key.charAt(key.length-1);
          if(Number(levelIndex) >= (addSpecIndex-1)){
            console.log(key)
              delete temp[key];
          }
      }
      if(addSpecIndex > 1){
          setAddSpecIndex(addSpecIndex-1)
          }
      setAddSubjectData(temp)
    }
  
     //Find the index of Category
     const catIndex = Object.values(reqmaster).findIndex(p => p.Category === categProp);
     console.log(catIndex)    
    
    const onFormSubmit = async (e) =>{
      e.preventDefault();
      const temp = {...addSubjectData};
      const tempArray = Object.values(temp);
      if(!tempArray.some(item => Object.values(reqmaster)[catIndex].Subject.includes(item))){
        const body = {id:categPropId, data:tempArray};
        console.log(body)
        const res = await addSubInCatReq(body);
        console.log(res)
      }else{
        alert("Subject value already exists in the database")
      }      
    }

    const handleDeleteClick = (e,k,row) =>{
      console.log(row.Subject)
      const res = delSubInArrReq({"id":row.id, "delSubValue":row.Subject})
    } 

    const handleAddSubject = (event) =>{
        let temp = {...addSubjectData};
        temp = {...temp, [event.target.name]:event.target.value};        
        setAddSubjectData(temp);
    }
    console.log(addSubjectData)
  
    return (
      <>
        <BackArrowContainer onClick={onClickBackArrow}><ArrowLeftIcon /><span >Back to Complaint Category Table</span></BackArrowContainer>
        <div style={{marginBottom:'20px', marginTop:'20px'}}> Add New Subject</div>
        
        <form style={{marginBottom:'20px', marginTop:'20px'}}>
            <label> Category</label>
            <input type="text" defaultValue={categProp} readOnly/>         
        </form>
  
        <form onSubmit={onFormSubmit} >       
  
            {[...Array(addSpecIndex)].map((e, i) =><Fragment key={i}>
            <SpecInputContainer>
            <label>Subject</label>
            <input name={`subject${i}`} onChange = {handleAddSubject} />          
            { i === (addSpecIndex-1) ? <><button>Submit</button>
            <AddIcon onClick={onClickaddicon} sx={{ fontSize: 30 }} />
            <RemoveIcon onClick={onClickremoveicon} sx={{ fontSize: 30 }} /></>:
            null
            }
            </SpecInputContainer></Fragment>)}
        </form>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell>Sl.No.</TableCell>
              <TableCell align="left">Complaint Category</TableCell>
              <TableCell align="left">Subject</TableCell>    
              <TableCell align="left">Delete</TableCell>
           </TableRow>
          </TableHead>
  
          <TableBody>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row,k) => (              
              <TableRow key={k} >
                <TableCell component="th" scope="row">
                  {(page)*(rowsPerPage)+k+1}
                </TableCell>
                <TableCell  align="left">
                  {row.Category}
                </TableCell>
                <TableCell  align="left">
                  {row.Subject}
                </TableCell>         
                <TableCell align="left">                 
                  <button style={{marginRight:'10px'}} type="button" onClick ={(e)=>handleDeleteClick(e,k,row)}>Delete</button>
                </TableCell>
            </TableRow>
            ))}
  
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                colSpan={3}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>      
      </TableContainer>
      </>  
    );
  }
  export default SubjectMaster;